<template>
    <b-modal id="exact_manager_modal">
        <template slot="modal-title">Manage Exact Online connection</template>
        <div v-if="project_data.connections.indexOf('Exact') === -1">
            <b-form-group label="API">
                <b-form-select
                        :state="validateURL"
                        v-model="selected_url"
                        :options="url_options"
                        required>
                    <!-- This slot appears above the options from 'options' prop -->
                    <template slot="first">
                        <option :value="null" disabled>-- Please select an option --</option>
                    </template>
                </b-form-select>
                <hr/>
                <b-button block
                          variant="primary"
                          @click="authorize">
                    Authorize
                </b-button>
            </b-form-group>
        </div>
        <div v-if="project_data.connections.indexOf('Exact') >= 0">
            <b-button block
                      variant="danger"
                      :disabled="clearing_credentials"
                      @click="clearCredentials">
                Clear credentials
            </b-button>
        </div>
    </b-modal>
</template>
<script>
    import Service from '../../../services/ExactConnectionService'

    export default {
        props: {
            project_data: {
                type: Object,
                default: () => []
            }
        },
        data() {
            return {
                urls: [],
                selected_url: '',
                authorizing: false,
                clearing_credentials: false,
            }
        },
        created() {
            Service.getData().then(res => {
                this.urls = res.data.urls;
            });
        },
        methods: {
            checkFields() {
                return this.selected_url != null;
            },
            authorize() {
                this.authorizing = true;
                let self = this;

                const data = {
                    api_url: this.selected_url,
                    project_id: this.project_data.project_id,
                };
                if (this.checkFields()) {
                    Service.authorize(data).then(res => {
                        if (res.data.success) {
                            let taskHandle = setInterval(() => {
                                Service.hasCredentials(data.project_id).then(res => {
                                    if (res.data.success &&
                                        res.data.hasOwnProperty('has_credentials') && res.data.has_credentials) {
                                        self.$emit('exact-authorization-complete', data.project_id);
                                        clearInterval(taskHandle);
                                    }
                                });
                            }, 5000);
                            window.open(res.data.auth_url, '_blank');
                        }

                        this.authorizing = false;
                    });
                }
            },
            clearCredentials() {
                this.clearing_credentials = true;

                Service.clearCredentials(this.project_data.project_id).then(res => {
                    if (res.data.success) {
                        this.project_data.connections = this.project_data.connections.filter(p => p !== 'Exact');
                    }

                    this.clearing_credentials = false;
                });
            }
        },
        computed: {
            url_options() {
                return this.urls.map(u => {
                    return {text: u, value: u};
                });
            },
            validateURL() {
                return this.selected_url.length > 0
            }
        }
    }
</script>
